import { useMemo } from 'react';
import { format } from 'date-fns';
import useVariables from './useVariables';
import usePeriod from './usePeriod';

export default function useCaption() {
  const { variableLabel } = useVariables();
  const { startDate, endDate } = usePeriod();
  const caption = useMemo(() => {
    let captionString = variableLabel || '';
    if (startDate) captionString += ` - ${format(startDate, 'dd/MM/yyyy')}`;
    if (endDate) captionString += ` a ${format(endDate, 'dd/MM/yyyy')}`;
    return captionString;
  }, [variableLabel, startDate, endDate]);

  return caption;
}
